import PropTypes from 'prop-types';
import React from 'react';
import onClickOutside from 'react-onclickoutside';
import classnames from 'classnames';
import _ from 'lodash';

import trainTime from '../../../lib/TrainTime';
import MomentPropTypes from "../../../helpers/MomentPropTypes";

import Calendar from '../../form/Calendar';
import PureRenderComponent from '../../PureRenderComponent';

export const DROPDOWN_POSITIONS = {
    LEFT: 'calendar-dropdown--left',
    RIGHT: 'calendar-dropdown--right'
};

class CalendarDropdown extends PureRenderComponent {

    static propTypes = {
        datetime: MomentPropTypes.isMoment,
        onChange: PropTypes.func,
        onClose: PropTypes.func,
        min: MomentPropTypes.isMoment,
        max: MomentPropTypes.isMoment,
        initialMonth: MomentPropTypes.isMoment,
        show: PropTypes.bool,
        autoFocus: PropTypes.bool,
        dropdownPosition: PropTypes.oneOf(Object.values(DROPDOWN_POSITIONS)),
    };

    static defaultProps = {
        datetime: trainTime(),
        onChange: _.noop,
        onClose: _.noop,
        min: null,
        max: null,
        initialMonth: null,
        show: false,
        autoFocus: false,
        dropdownPosition: DROPDOWN_POSITIONS.LEFT,
    };

    handleClickOutside () {
        this.props.onClose();
    }

    render () {
        const { datetime, min, max, initialMonth, show, autoFocus, onChange, dropdownPosition } = this.props;
        const calendarClass = classnames(
            'box',
            'box--rounded',
            'box--padded',
            'calendar-dropdown',
            dropdownPosition,
            {
                'calendar-dropdown--hidden': !show
            }
        );

        return (
            <div className={ calendarClass }>
                <Calendar
                    show={ show }
                    autoFocus={ autoFocus }
                    selected={ datetime }
                    onChange={ onChange }
                    min={ min }
                    max={ max }
                    initialMonth={ initialMonth }
                />
            </div>
        );
    }
}

export default onClickOutside(CalendarDropdown);



// WEBPACK FOOTER //
// ./src/components/search/dates/CalendarDropdown.js